/**
 * Created by Marcus Zhao on 12/01/2020
 * -------------------------------------
 */

import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ReplaySubject, Subscription, Subject, of as observableOf } from 'rxjs';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { EntityService } from '@tamalelibs/services/entity.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { OpenDynamicComponentService } from '../../../../pages/home/home-open-dynamic-component';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { ValidRelationshipType } from '@tamalelibs/models/valid-relationship-type.model';
import { TemplateControlValue } from '@tamalelibs/models/template-control-value.model';
import { catchError, take, debounceTime, filter } from 'rxjs/operators';
import { ContactService } from '@tamalelibs/services/contact.service';
import { HomeViewModel } from '../../../../pages/home/home-view.model';
import { StoreQuerierService } from '../../../../services/store-querier.service';
import { validRelationshipTypeSelector } from '../../../../redux/reducers/valid-relationship-type.reducer';
import { contactNewAddedJobTitleSelector, contactTemplateConfigSelector } from '@tamalelibs/redux/contact.reducer';
import { EntityBack, EntityDialogOpenOptions, EntityDialogType } from '../../../entity-dialog/entity-dialog.model';
import { ControlId, CompanyAction, ContactRelationshipType, ContactTemplateType, ContactAction } from '../../../contact-dialog-new/contact-dialog.model';
import { ADD_JOB_TITLE, REMOVE_JOB_TITLE, ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import { EntityType } from '@tamalelibs/models/entity-type.model';
import { Entity } from '@tamalelibs/models/entity.model';
import * as _lodash from 'lodash';
import { UUID } from 'angular2-uuid';
import { OnDestroy } from '@angular/core';
import { StringLiteralsPipe } from '../../../../pipes/translate.pipe';

@Component({
    selector: 'tam-contact-former-employment',
    templateUrl: './contact-former-employment.component.html',
    styleUrls: ['./contact-former-employment.component.scss'],
    standalone: false
})
export class ContactFormerEmploymentComponent implements OnInit, OnDestroy {
    @Input() childConfig: any;
    config: any;

    @Input() valueChangeSubject: ReplaySubject<TemplateControlValue>;
    @ViewChild('dropDownElCompany', { static: false }) entityElCompany;
    @ViewChild('dropDownElJobTitle', { static: false }) entityElJobTitle;
    @ViewChild('dropDownSYear', { static: false }) dateElStartYear;
    @ViewChild('dropDownEYear', { static: false }) dateElEndYear;

    isNotFly = true;
    readOnly = false; // flag to disable auto complete
    hasPermissionToView = true;
    selectedDictionary: any = {}; // selected items, using dictionary for quickly removing duplicates
    // suggestionItems: Array<any> = []; // suggestion items based on search, sub set of dataItems
    // defaultItems: Array<any> = []; // defaultItems items based on search, sub set of dataItems
    // selectedItem: any; // selected items, sub set of dataItems.

    companySuggestionItems: Array<any> = [];
    companyDefaultItems: Array<any> = [];
    companySelectedItem: any;

    jobTitleSuggestionItems: Array<any> = [];
    jobTitleDefaultItems: Array<any> = [];
    jobTitleSelectedItem: any;

    sYearSuggestionItems: Array<any> = [];
    sYearDefaultItems: Array<any> = [];
    sYearSelectedItem: any;

    eYearSuggestionItems: Array<any> = [];
    eYearDefaultItems: Array<any> = [];
    eYearSelectedItem: any;
    searchType = 0; // 0 company 1 jobtle 2 startY 3 endY
    placeholder = '';
    hintContent = '';
    readonlyTip = '';
    showCompanyError = false;
    showEndYearError = false;
    searchId = 'searchId';
    searchItem = '';

    private _searchText = '';
    private _searchValue;
    private _filterHandler$: Subject<string> = new Subject();
    private _destroySubscriptions: Array<Subscription> = [];
    private _validRelationshipTypes: Array<ValidRelationshipType>;
    private _defaultContactAllRelationshipTypes;
    // this var is to save the original company value which has changed
    private _originalCompany = null;
    // this var is to save the original job title value which has changed
    private _originalJobTitle = null;
    // when create the valid company on fly, the current employment need to move to former employment
    // when create the invalid company on fly, the current employment cannot move to former employment
    private _isCreateValidEntity = true;
    private _lastSelectedValue = null;
    private _contactTemplateConfig: Subscription;

    constructor(
        private _contactTemplateService: ContactTemplateService,
        private _entityService: EntityService,
        private _contactService: ContactService,
        private _store: Store<AppState>,
        private _openDynamicComponentService: OpenDynamicComponentService,
        private _homeViewModel: HomeViewModel,
        private _storeQuerier: StoreQuerierService,
    ) { }

    ngOnInit() {
        this.config = this.childConfig.config;
        this._destroySubscriptions.push(
            this._store.pipe(
                select(validRelationshipTypeSelector),
                filter(res => res && res.length > 0)
            ).subscribe(res => {
                this._validRelationshipTypes = res;
                this._getRelationshipTypeSuggestionItems();
                this._initRelationshipAndFormerEmploymentStaticValue(); // only for edit
            }),

            this._store.pipe(
                select(contactNewAddedJobTitleSelector),
                filter(res => res && res.length > 0),
            ).subscribe(res => this._handleNewAddedJobTitle(res)),

            // valid employment end yaer
            this._contactTemplateService.validInputSubject$.subscribe((res) => {
                if (this.config.prefixId === res.prefixId && !this.eYearSelectedItem) {
                    this.showEndYearError = true;
                    this.hintContent = StringLiteralsPipe.translate('general.required_field');
                } else {
                    this.hintContent = null;
                }
            }),

            this._openDynamicComponentService.feedbackSubject$.subscribe((feedback: EntityBack) => {
                if (feedback.controlId === this.config.controlID) {
                    const indexNumber = parseInt(feedback.currentId, 0);
                    let indexString = '';
                    if (indexNumber > 1) {
                        indexString = (indexNumber - 1).toString();
                    }
                    if (this.config.prefixId === indexString) {
                        this._entityService.getEntityListByIdsQuick([feedback.entityId])
                            .subscribe(res => {
                                this._setFlyValue(res, feedback);
                            });
                        this._changeValueSet();
                    }
                }
            }),

            this._filterHandler$.pipe(
                debounceTime(250),
            ).subscribe(filterStr => {
                if (filterStr && filterStr.length > 0) {
                    this._searching(filterStr);
                } else {
                    this._searching('');
                }
            }),
        );
        if (this.config.action === ContactTemplateType.EditContact) {
            // edit contact
            this._initEditValue();
        }
        this.searchType = 1;
        this._searching('');
        // common function
        this._getEmploymentSuggestionYear();
        if (!this.childConfig.config.isHidden) {
            this._changeValueSet();
        }
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    handleFilter(value, index) {
        this.searchType = index;
        this._searchValue = value;
        this._filterHandler$.next(value);
    }

    onOpen(event: any) {

    }

    clickAddCtrol(event) {
        this.updateContorlLayout(true);
    }

    clickRemoveLayout(event) {
        this.updateContorlLayout(false);
        this.jobTitleSelectedItem = null;
    }

    updateContorlLayout(isAdd: boolean = true) {
        const newCtrlJson = _lodash.cloneDeep(this.childConfig);
        if (isAdd) {
            newCtrlJson.config.controlID = newCtrlJson.config.controlID + UUID.UUID();
            newCtrlJson.config.isCanDelete = true;
            newCtrlJson.config.isHidden = false;
            newCtrlJson.config.isSupportDynamic = false;
            newCtrlJson.config.editValue = null;
        }
        // this.valueChangeSubject.next(newCtrlJson);
        this._contactTemplateService.actionSubject$.next({
            type: isAdd ? ContactAction.AddControl : ContactAction.RemoveControl,
            payload: {
                ctrlType: this.config.controlType,
                ctrl: newCtrlJson,
                secSName: this.config.secSName,
                controlID: this.config.controlID,
            }
        });
    }

    onEnter(event) {
        // Handled by KendoDropdownEscFixDirective
        event.stopImmediatePropagation();
    }

    /**
     * former employment job title change
     *
     * @param {*} tappedItem
     * @memberof ContactFormerEmploymentComponent
     */
    valueChangeJobTitle(tappedItem) {
        if (tappedItem) {
            this.hintContent = '';
            this.showCompanyError = false;
            this._contactTemplateService.changeValueStatus = true;
            if (tappedItem.id === this.searchId) {
                const deleteIndex = this.jobTitleSuggestionItems.findIndex(item => item.id === this.searchId);
                this.jobTitleSuggestionItems.splice(deleteIndex, 1);
                this.createJobTitle();
                return;
            }
        }
        // below function is to adjust if we need to dispatch the new added job title to store
        // 1. need to be the relationship part or former employment part
        // 2. need contain the fake id
        if (tappedItem && tappedItem.id && tappedItem.id.toString().indexOf('fakeId') !== -1
            && ((this._originalJobTitle && this._originalJobTitle.id && this._originalJobTitle.id !== tappedItem.id) || !this._originalJobTitle)) {
            this._store.dispatch({
                type: ADD_JOB_TITLE,
                payload: {
                    name: tappedItem.name,
                    id: tappedItem.id,
                }
            });
        }
        if (this._originalJobTitle && this._originalJobTitle.id && (!tappedItem || this._originalJobTitle.id !== tappedItem.id)
            && this._originalJobTitle.id.toString().indexOf('fakeId') !== -1) {
            this._store.dispatch({
                type: REMOVE_JOB_TITLE,
                payload: {
                    name: this._originalJobTitle.name,
                    id: this._originalJobTitle.id,
                }
            });
        }
        this._originalJobTitle = this.jobTitleSelectedItem;
        // up function is to adjust if need to dispatch the new added job title to store
        this._changeValueSet();
        
        // Clear the job title dropdown filter text to keep it clean after selection
        setTimeout(() => {
            if (this.entityElJobTitle) {
                // Access the searchbar input directly and clear it
                const searchInput = this.entityElJobTitle.searchbar?.nativeElement;
                if (searchInput) {
                    searchInput.value = '';
                }
                // Also trigger filterChange with empty string
                if (this.entityElJobTitle.filterChange) {
                    this.entityElJobTitle.filterChange.emit('');
                }
            }
        }, 0);

    }
    /**
     * value changed company for former employment
     *
     * @param {*} tappedItem
     * @memberof ContactFormerEmploymentComponent
     */
    valueChangeCompany(tappedItem) {
        if (this.companySelectedItem) {
            this._originalCompany = {
                id: this.companySelectedItem.id,
                name: this.companySelectedItem.name,
            };
            this._changeValueSet();
        }
    }

    valueChangeEndYear() {
        this.hintContent = '';
        this._changeValueSet();
    }

    valueChangeStartYear() {
        this._changeValueSet();
    }

    clearValue(id) {
        // simulate user press esc this will toggle the dropdown and remove keyword on filter
        const event = new UIEvent('kendodropdown_keydown');
        event['keyCode'] = 27;
        switch (id) {
            case 0:
                this.entityElJobTitle.keydown(event);
                this.jobTitleSelectedItem = null;
                this._searching(0);
                break;
            case 1:
                this.entityElCompany.keydown(event);
                this.companySelectedItem = null;
                this._searching(1);
                break;
            case 2:
                this.dateElStartYear.keydown(event);
                this.sYearSelectedItem = null;
                this._searching(2);
                break;
            case 3:
                this.dateElEndYear.keydown(event);
                this.eYearSelectedItem = null;
                break;
        }
        this._changeValueSet();
    }

    createEntity() {
        this._showAddEntityDialog();
    }

    createJobTitle() {
        const invalidRelationshipTypeId = 'fakeId' + new Date().getTime();
        const flyRelationship = {
            id: invalidRelationshipTypeId,
            name: this._searchValue
        };
        this.jobTitleSelectedItem = flyRelationship;
        this._originalJobTitle = flyRelationship;
        this._store.dispatch({
            type: ADD_JOB_TITLE,
            payload: flyRelationship
        });
        this.entityElJobTitle.clearFilter();
        this.entityElJobTitle.toggle(false);
        this._changeValueSet();
    }

    private _handleNewAddedJobTitle(newAddedJobTitle) {
        this._filterContactAllRelationship(this._validRelationshipTypes, newAddedJobTitle);
    }

    private _initEditValue() {
        this.eYearSelectedItem = this.config.editValue && this.config.editValue.endYear ? this.config.editValue.endYear : '';
        this.sYearSelectedItem = this.config.editValue && this.config.editValue.startYear ? this.config.editValue.startYear : '';
        // this._changeValueSet(false);
        // edit contact
        if (this.config.editValue) {
            if (this.config.editValue.childEntityName === '******' && this.config.editValue.childEntityId !== '') {
                this.companySelectedItem = {
                    id: this.config.editValue.childEntityId,
                    name: this.config.editValue.childEntityName,
                    isPublic: false
                };
                this.readonlyTip = 'Company field contains a private entity that you have no permission to view';
                this.readOnly = true;
                this.hasPermissionToView = false;
                this._changeValueSet(false);
            } else if (this.config.editValue.childEntityId && this.config.editValue.childEntityName !== '******') {
                this._getEntityDetailWithoutAdhoc(this.config.editValue.childEntityId);
            }

        }
    }

    /**
     * set for
     *
     * @private
     * @memberof ContactFormerEmploymentComponent
     */
    private _initRelationshipAndFormerEmploymentStaticValue() {
        if (this.config.editValue && this.config.editValue.relationshipTypeId) {
            // below part is for new added control after open the dialog, such as change the company function
            // this need to get from store
            // because if we add one control, the init has finished, and the new added control will not get the store value
            let tempValidRelationshipArray = []; // we cannot change the original array, so need to apply a new one
            if (this._storeQuerier.queryBySelector(contactNewAddedJobTitleSelector).length > 0) {
                const convertNewAddedJobTitleArray = []; // need to convert the data model from the store model to the validrelationship model
                this._storeQuerier.queryBySelector(contactNewAddedJobTitleSelector).forEach(ele => {
                    convertNewAddedJobTitleArray.push({
                        relationshipType: {
                            id: ele.id,
                            name: ele.name
                        }
                    });
                });
                tempValidRelationshipArray = this._validRelationshipTypes.concat(convertNewAddedJobTitleArray);
            } else {
                tempValidRelationshipArray = this._validRelationshipTypes;
            }


            // new added control after open the dialog function is over
            tempValidRelationshipArray.forEach(element => {
                if (element.relationshipType.id === this.config.editValue.relationshipTypeId) {
                    this.jobTitleSelectedItem = {
                        id: element.relationshipType.id,
                        name: element.relationshipType.name,
                        isPublic: true
                    };
                }
            });

            this._changeValueSet();
        }
    }

    // this function is for create and edit
    // get the valid relationship: contact all - contact all
    private _filterContactAllRelationship(relationshipTypes, newAddedJobTitle?: Array<any>) {
        this.jobTitleSuggestionItems = [];
        relationshipTypes.forEach(element => {
            if (element.childEntityType.id === EntityType.CONTACT.id &&
                element.parentEntityType.id === EntityType.CONTACT.id) {
                this.jobTitleSuggestionItems.push({
                    id: element.relationshipType.id,
                    name: element.relationshipType.name,
                    isPublic: true
                });
            }
        });
        // this function is for new added job title when create a new job title in basic information
        if (newAddedJobTitle && newAddedJobTitle.length > 0) {
            newAddedJobTitle.forEach(item => {
                if (item.count > 0) {
                    this.jobTitleSuggestionItems.push({
                        id: item.id,
                        name: item.name,
                        isPublic: true
                    });
                }
            });
        }
        this.jobTitleSuggestionItems = _lodash.uniqWith(
            this.jobTitleSuggestionItems, _lodash.isEqual);
        if (this.jobTitleSuggestionItems.length !== 0) {
            this.jobTitleSuggestionItems = _lodash.sortBy(this.jobTitleSuggestionItems, item => item.name);
        }
        this._defaultContactAllRelationshipTypes = this.jobTitleSuggestionItems;
    }

    // this function is for create and edit
    private _getEntityDetailWithoutAdhoc(id) {
        this._entityService.getEntityDetailWithoutAdhoc(id)
            .pipe(take(1))
            .subscribe(response => {
                if (response) {
                    const entity = Entity.parse(response);
                    this.companySelectedItem = entity;
                    this._changeValueSet();
                }
            });
    }

    /**
     * get former job title
     *
     * @private
     * @memberof ContactFormerEmploymentComponent
     */
    private _getRelationshipTypeSuggestionItems() {
        this._filterContactAllRelationship(this._validRelationshipTypes);
    }

    // this function is for create and edit
    private _getEmploymentSuggestionYear() {
        this.sYearSuggestionItems = [];
        this.eYearSuggestionItems = [];
        // here is for employment start year filter
        const startYear = new Date().getFullYear();
        for (let i = startYear; i >= 1970; i--) {
            this.sYearSuggestionItems.push(i);
        }
        this.eYearSuggestionItems = _lodash.cloneDeep(this.sYearSuggestionItems);
    }

    private _searching(text) {
        switch (this.searchType) {
            case 0:
                if (text) {
                    this.jobTitleSuggestionItems = this._defaultContactAllRelationshipTypes.filter((item) =>
                        item.name.toLowerCase().indexOf(text.toLowerCase()) !== -1);

                    const index = this._defaultContactAllRelationshipTypes.findIndex((content) => content.name.toLowerCase() === text.toLowerCase());
                    if (this.config.isAllowFly && index < 0 && text) {
                        const searchItem = { 'name': text, 'id': this.searchId };
                        this.jobTitleSuggestionItems.push(searchItem);
                    }
                } else {
                    this.jobTitleSuggestionItems = this._defaultContactAllRelationshipTypes;
                }

                break;
            case 1:
                if (this.entityElCompany && this.entityElCompany.loading) {
                    this.entityElCompany.loading = true;
                }
                this._searchText = text;
                this._contactTemplateConfig = this._store.pipe(
                    select(contactTemplateConfigSelector),
                    filter(val => val !== undefined)
                ).subscribe(res => {
                this.config.source = res.contains[3].container[0][0].config.source;
                });
                this._destroySubscriptions.push(this._contactTemplateConfig);
                if (Array.prototype.isPrototypeOf(this.config.source) && this.config.source.length === 0) {
                    return;
                } else {
                    this._contactService.getContactListByText(this._searchText, null, this.config.source).pipe(
                    take(1),
                    catchError((e) => {
                        return observableOf();
                    }),
                ).subscribe(
                    res => {
                        this._searchingDone(res, text);
                        if (this.entityElCompany && this.entityElCompany.loading) {
                            this.entityElCompany.loading = false;
                        }
                    }
                );
                }
                break;
            case 2:
                this.sYearSuggestionItems = [];
                const startYear = new Date().getFullYear();
                for (let i = startYear; i >= 1970; i--) {
                    if (i.toString().indexOf(text) !== -1) {
                        this.sYearSuggestionItems.push(i);
                    }
                }
                break;
            case 3:
                this.eYearSuggestionItems = [];
                const endYear = new Date().getFullYear();
                for (let i = endYear; i >= 1970; i--) {
                    if (i.toString().indexOf(text) !== -1) {
                        this.eYearSuggestionItems.push(i);
                    }
                }
                break;
        }
    }

    private _searchingDone(entityList, text) {
        this.searchItem = '';
        this.companySuggestionItems = this._entityService.mapEntityBriefList(entityList);
        const index = this.companySuggestionItems.findIndex((content) => content.name.toLowerCase() === text.toLowerCase() || content.shortName.toLowerCase() === text.toLowerCase());
        if (index < 0 && text) {
            this.searchItem = text;
        }
        if (text === '') {
            this.companyDefaultItems = this.companySuggestionItems;
        }
    }

    /**
     * on the fly entity for company
     *
     * @private
     * @memberof ContactFormerEmploymentComponent
     */
    private _showAddEntityDialog() {
        let index;
        this._homeViewModel.increment();
        this._homeViewModel.getFlyIndex().pipe(take(1)).subscribe(res => index = res);
        const _entityDialogOpenOptions = new EntityDialogOpenOptions();
        _entityDialogOpenOptions.openType = EntityDialogType.NewEntity;
        // _entityDialogOpenOptions.entityName = name;
        _entityDialogOpenOptions.instanceId = index.toString();
        _entityDialogOpenOptions.searchValue = this._searchValue;
        _entityDialogOpenOptions.controlId = this.config.controlID;
        _entityDialogOpenOptions.isCreateValidEntity = this._isCreateValidEntity;
        this._openDynamicComponentService.openDialog$.next(_entityDialogOpenOptions);
    }

    private _setFlyValue(entityList, feedback: EntityBack) {
        if (entityList) {
            const item = this._entityService.mapEntityBriefList(entityList)[0];
            if (item) {
                this._originalCompany = this.companySelectedItem;
                this.companySelectedItem = item;
                this.companySuggestionItems = this.companyDefaultItems;
                this.companySuggestionItems.unshift(this.companySelectedItem);
                this._changeValueSet();
                this.hintContent = '';
                this.showCompanyError = false;
                if (feedback.isCreateValidEntity) {
                    this._contactTemplateService.actionSubject$.next({
                        type: CompanyAction.CreateValidCompany,
                        payload: {
                            originalCompany: this._originalCompany,
                            targetCompany: this.companySelectedItem,
                        }
                    });
                } else {
                    if (this.config.controlID === 'Company') {
                        this._contactTemplateService.actionSubject$.next({
                            type: CompanyAction.CreateInvalidCompany,
                            payload: {
                                originalCompany: this._originalCompany,
                                targetCompany: this.companySelectedItem,
                            }
                        });
                    }
                }
            }
        }
        this._isCreateValidEntity = true;
    }

    /**
     * set value
     *  combine all controls value to combineValue
     * @private
     * @param {boolean} [isFromUser=false]
     * @memberof ContactFormerEmploymentComponent
     */
    private _changeValueSet(isFromUser: boolean = false) {
        const jobTitleIds = (this.jobTitleSelectedItem && this.jobTitleSelectedItem.id) ? this.jobTitleSelectedItem.id : '';
        const companyId = (this.companySelectedItem && this.companySelectedItem.id) ? this.companySelectedItem.id : '';
        const combineValue = { 'companyID': companyId, 'titleType': jobTitleIds, 'startDate': this.sYearSelectedItem, 'endYear': this.eYearSelectedItem || 0 };
        if (combineValue) {
            const value = new ContactTemplateControlValue(combineValue, this.config.componentType,
                this.config, isFromUser);
            this._store.dispatch(
                new ChangeContactTemplateValueSet(
                    value,
                    'prefix',
                    this.config.prefixId
                )
            );
        }
    }
}
